import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Search01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="search-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.84 5C8.06237 5 5 8.06237 5 11.84C5 15.6176 8.06237 18.68 11.84 18.68C13.7026 18.68 15.3913 17.9355 16.6248 16.7279C16.6264 16.7263 16.6281 16.7246 16.6298 16.723C17.8951 15.4817 18.68 13.7525 18.68 11.84C18.68 8.06237 15.6176 5 11.84 5ZM18.7177 17.3941C19.945 15.8763 20.68 13.944 20.68 11.84C20.68 6.9578 16.7222 3 11.84 3C6.9578 3 3 6.9578 3 11.84C3 16.7222 6.9578 20.68 11.84 20.68C13.8974 20.68 15.7907 19.9771 17.2928 18.7984L20.1047 21.5187C20.5016 21.9027 21.1347 21.8922 21.5187 21.4953C21.9027 21.0984 21.8922 20.4653 21.4953 20.0813L18.7177 17.3941Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
